if ( typeof ProductPage !== 'function' ) {
	
	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('.product-gallery');

			// qty helper

			if ( this.querySelector('.product__quantity') ) {
				this.querySelector('.product__quantity').addEventListener('click', e=>{
					e.target.select();
				});
			}

			// Product variant event listener for theme specific logic

			const productVariants = this.querySelector('product-variants');
			if ( productVariants ) {
				productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:productVariants});
			}

			// Look at add to cart button for changes

			if ( this.querySelector('.product__add-to-cart') ) {
				const addToCartHolder = this.querySelector('.product__cart-actions-holder');
				new MutationObserver((mutationsList, observer)=>{
					for ( const mutation of mutationsList ) {
						if ( mutation.attributeName == 'class' ) {
							addToCartHolder.classList.remove('disabled');
							addToCartHolder.classList.remove('working');
							if ( mutation.target.classList.contains('disabled') ) {
								addToCartHolder.classList.add('disabled');
							}
							if ( mutation.target.classList.contains('working') ) {
								addToCartHolder.classList.add('working');
							}
						}
					} 
				}).observe(this.querySelector('.product__add-to-cart'), {
					attributes: true, childList: false, subtree: false
				});
				if ( this.querySelector('.product__add-to-cart').classList.contains('disabled') ) {
					addToCartHolder.classList.add('disabled');
				}
			}

			// Helper events for different media

			this.productGallery.addEventListener('change', e=>{
				if ( this.productGallery.items[this.productGallery.index].dataset.productMediaType == 'model' ) {
					setTimeout(()=>{
						this.productGallery.toggleDragging(false);	
					}, 15);
					if ( this.xrButton ) {
						this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.items[this.productGallery.index].dataset.mediaId);
					}
				}
				this._pauseAllMedia();
			});

			// Calculate complete product height (add extra sections)

			if ( ! this.classList.contains('featured-product') ) {

				const productOffers = this.querySelector('.product__offers > div');
				this._EVENT_SCROLL = e=>{
					if ( window.innerHeight < productOffers.offsetHeight ){
						let y = this.getBoundingClientRect().y,
								z = productOffers.offsetHeight - window.innerHeight;
						if ( Math.abs(y) < z ) {
							productOffers.style.top = `${y}px`;
						} else if ( Math.abs(y) >= z ) {
							productOffers.style.top = `${-z}px`;
						}
					}
				};
				window.addEventListener('scroll', this._EVENT_SCROLL, {passive:true});

				this.style.minHeight = `${productOffers.offsetHeight}px`;
				setInterval(()=>{
					this.style.minHeight = `${productOffers.offsetHeight}px`;
				}, 500);

			}

			// Add to cart event

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('.product__add-to-cart') ) {
					this.querySelector('.product__add-to-cart').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('.product__form') ) {
					this.querySelector('.product__form').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar .close-sidebar').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;

			// variant media filtering
			this._filterGalleryByVariant(variant);

			// scroll to featured media of variant
			if ( variant && variant.featured_media != null ) {
				let variantImg = this.productGallery.querySelector('.product-gallery__item[data-media-id="' + variant.featured_media.id + '"]');
				if ( variantImg ) {
					if ( this.productGallery.classList.contains('js-enabled') ) {
						this.productGallery.changeSlide(parseInt(variantImg.dataset.index));
					} else {
						this.productGallery.dataset.initialIndex = variantImg.dataset.index;
					}
				}
			}

		}

		_filterGalleryByVariant(variant){

			const slider = this.productGallery;
			const allItems = Array.from(slider.querySelectorAll('.product-gallery__item[data-media-id]'));

			// Build lowercase set of this variant's option values (e.g. ["braun", "xs"])
			const optionValues = variant
				? variant.options.map(o => o.toLowerCase())
				: [];

			// Show/hide items and collect visible ones.
			// Naming convention: "ASO-braun-XS-1" → segments ["aso","braun","xs","1"]
			// A image is shown if:
			//   a) no variant is selected (show all), OR
			//   b) none of the known size/option tokens appear in its alt segments (→ shared image, always visible), OR
			//   c) at least one of its alt segments matches a selected option value
			const allOptionTokens = this._getAllOptionTokens();
			const visibleItems = [];

			allItems.forEach(item => {
				// Prefer filename from CDN URL (always contains original filename regardless of alt text)
				// CDN URL format: .../products/ASO-braun-XS-1_abc123def.jpg?width=...
				// Fall back to data-media-alt if no img found
				const img = item.querySelector('img');
				let rawName = '';
				if ( img ) {
					const src = img.getAttribute('src') || img.getAttribute('srcset') || '';
					const segment = src.split('/').pop().split('?')[0];
					// Remove Shopify's _[hex hash] suffix before extension
					rawName = segment.replace(/_[a-f0-9]{8,}(\.[^.]+)$/i, '$1').replace(/\.[^.]+$/, '').toLowerCase();
				}
				if ( ! rawName ) rawName = item.dataset.mediaAlt || '';
				const altSegments = rawName.split(/[-_\s]+/).filter(Boolean);
				let show;

				if ( optionValues.length === 0 ) {
					// No variant selected → show everything
					show = true;
				} else {
					const hasAnyToken = altSegments.some(seg => allOptionTokens.includes(seg));
					if ( ! hasAnyToken ) {
						// Image has no variant token → shared/generic image, always show
						show = true;
					} else {
						// Image is variant-specific → show only if it matches current variant options
						show = altSegments.some(seg => optionValues.includes(seg));
					}
				}

				item.style.display = show ? '' : 'none';
				item.setAttribute('aria-hidden', show ? 'false' : 'true');
				if ( show ) visibleItems.push(item);
			});

			// Re-index visible items so changeSlide(data-index) stays correct
			visibleItems.forEach((item, i) => { item.dataset.index = i; });

			// Patch the slider's internal state so all its methods work on visible items only
			if ( slider.classList.contains('js-enabled') ) {

				// Re-wire IntersectionObserver to visible items only
				allItems.forEach(item => slider.OBSERVER.unobserve(item));
				visibleItems.forEach(item => slider.OBSERVER.observe(item));

				// Replace items array and reset position
				slider.items = visibleItems;
				slider.length = visibleItems.length;
				slider.index = 0;

				// Reset CSS order
				visibleItems.forEach((item, i) => { item.style.order = i; });

				// Reset transform and classes
				allItems.forEach(item => item.classList.remove('before-active', 'after-active', 'active', 'enable-tab'));
				if ( visibleItems[0] ) visibleItems[0].classList.add('active', 'enable-tab');

				// Snap to start without animation
				slider.holder.classList.add('no-transitions');
				slider.holder.style.transform = 'translateX(0)';
				setTimeout(() => slider.holder.classList.remove('no-transitions'), 10);

				// Update counter and nav
				slider._checkNav(0);
				if ( visibleItems[0] ) slider._setHeight(0, false);

				// Update the "X / Y" total in navigation
				const noEl = slider.querySelector('.product-gallery__no');
				if ( noEl ) {
					noEl.innerHTML = `<span class="product-gallery__index">1</span> / ${visibleItems.length}`;
					slider.indexEl = slider.querySelector('.product-gallery__index');
				}

			}

		}

		_getAllOptionTokens(){
			// Collect all possible option values from variant JSON so we can detect "shared" images
			const variantDataEl = this.querySelector('product-variants script[type="application/json"]');
			if ( ! variantDataEl ) return [];
			try {
				const variants = JSON.parse(variantDataEl.textContent);
				const tokens = new Set();
				variants.forEach(v => v.options.forEach(o => tokens.add(o.toLowerCase())));
				return Array.from(tokens);
			} catch(e) { return []; }
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}

	}
	
	if (typeof customElements.get("product-page") == "undefined") {
		customElements.define("product-page", ProductPage);
	}
	
}